<template>
  <div>
    <!-- <h2>O letních táborech</h2> -->

    <h3>Zotavovací akce</h3>

    <p>
      Zotavovací akce je organizovaný pobyt 30 a více dětí ve věku do 15 let na
      dobu delší než 5 dnů, jehož účelem je posílit zdraví dětí, zvýšit jejich
      tělesnou zdatnost, popřípadě i získat specifické znalosti nebo dovednosti.
      Za zotavovací akci se považuje i výchovně rekreační tábor pro děti
      (pořádaný na základě zákona o sociálně právní ochraně dětí) a to i v
      případě, že se ho účastní mladiství. Osoba, která pořádá zotavovací akci
      má povinnost její konání ohlásit orgánu ochrany veřejného zdraví (dále jen
      OOVZ). Součástí oznamovací povinnosti musí být uvedeno místo a termín
      konání akce, způsob zásobování pitnou vodou a způsob zajištění stravování
      účastníků akce. V případě, že tábor není zásobován pitnou vodou z
      veřejného vodovodu, musí pořádající osoba předložit i protokol o kráceném
      rozboru jakosti pitné vody. Na zotavovacích akcích vykonává OOVZ státní
      zdravotní dozor nad plněním povinností stanovených zákonem a na základě
      zákona.
    </p>

    <h3>Jiná podobná akce</h3>

    <p>
      Je organizovaný pobyt dětí v počtu menším než 30 dětí nebo po dobu kratší
      5 dnů. Nepatří sem akce pořádané pro děti v poměru rodinném a obdobném.
      Osoba provozující jiné podobné akce nemá tzv. ohlašovací povinnost OOVZ,
      musí zajistit pouze: zásobování akce nezávadnou pitnou vodou, hygienicky
      nezávadný stav zařízení, účast zdravotně způsobilých fyzických osob, které
      budou činné jako dozor a účast fyzických osob vykonávajících činnosti
      epidemiologicky závažné (stravovací provoz), které budou mít platný
      zdravotní průkaz a znalosti nutné k ochraně veřejného zdraví.
    </p>

    <p>
      Státní zdravotní dozor na tzv. jiných podobných akcích je vykonáván pouze
      v případě šetření podnětů, nebo pokud provozovatel tuto akci OOVZ ohlásil.
    </p>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$emit("caption", "O letních táborech");
  }
};
</script>
